import { HourglassOutlined } from '@ant-design/icons';
import { useContext } from 'react';
import DomainContext from 'services/domainContext';
import ProfileContext from 'services/profileContext';
import styles from 'styles/components/profileValidationBanner.module.scss';
import {
  shouldShowFetchingBanner,
} from 'utils/profileValidation';

const ProfileValidationBanner = () => {
  const profileContext = useContext(ProfileContext);
  const domainContext = useContext(DomainContext);
  const profile = profileContext?.profile;

  if (!shouldShowFetchingBanner(profile, domainContext?.domains)) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <HourglassOutlined className={styles.icon} />
        <span className={styles.message}>
          We're pulling your domain metrics.
          {' You can already request backlinks with your 15 Karma Points.'}
        </span>
      </div>
    </div>
  );
};

export default ProfileValidationBanner;
